



































	import AbpBase from "../../../lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  InsertAssayCategoryItem,
  UpdateAssayCategoryItem,
  GetAssayCategoryItem,
} from "../../../api/basicDictionary";
import { QueryAssayItems } from "@/api/assay";
@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  @Prop() data: any;
  form: any = {
    itemCode: "",
    itemName: ""
  };
  dialogTitle: string = "获取查询指标";
  rules = {
    itemCode: [{ required: true, message: "请输入内容", trigger: "blur" }],
    itemName: [{ required: true, message: "请输入内容", trigger: "blur" }],
  };
  itemsPageRequest = {
    page: 1,
    pageSize: 10,
    queryString: "",
  };
  itemColumns = [
    {
      key: "itemCode",
      title: "指标编码",
    },
    {
      key: "itemName",
      title: "指标名称",
    },
    {
      title: "操作",
      width: 100,
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: () => {
                  this.loadItem(p.row);
                },
              },
            },
            "载入"
          ),
        ]);
      },
    },
  ];
  itemsData = [];
  itemsLoading = false;
  itemsTableTotalSize = 0;
  itemsQueryString: string = "";

  query() {
    this.itemsPageRequest.page = 1;
    this.getItemsData();
  }

  async getItemsData() {
    this.itemsLoading = true;
    let res = await QueryAssayItems(this.itemsPageRequest);
    this.itemsLoading = false;
    this.itemsData = res.items;
    this.itemsTableTotalSize = res.totalCount;
  }

  itemsPageChange(val: any) {
    this.itemsPageRequest.page = val;
    this.getItemsData();
  }

  loadItem(row: any) {
    this.form.itemCode = row.itemCode;
    this.form.itemName = row.itemName;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      (this.$refs.form as any).resetFields();
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  created() {
    this.getData();
  }

  async confirm() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
       this.$emit("selectItem",this.form);
      }
    });
  }

  async getData() {

  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdScreening/SelectItem.vue